import React from 'react';
export const CustomLogo = ({ fallBack: FallBack, customLogo: Custom, }) => {
    if (Custom)
        return React.createElement(Custom, null);
    return React.createElement(FallBack, null);
};
//# sourceMappingURL=CustomLogo.js.map